<template>
    <div id="app">
        <v-card color="grey lighten-5" flat>
            <v-layout row wrap>
                <v-flex xs12 sm12>
                    <v-toolbar size="120px" dark color="info">
                        <v-toolbar-title >Bilet Listesi</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-flex v-if="tablegorunum" xs12 sm4 md4>

                            <v-text-field flat="" solo-inverted="" hide-details v-model="search1" label=" Ara"
                                append-icon="search"></v-text-field>
                        </v-flex>
                        <v-flex v-if="listegorunum" xs12 sm4 md4>

                            <v-text-field flat="" solo-inverted="" hide-details v-model="searchliste" label=" Ara"
                                append-icon="search"></v-text-field>
                        </v-flex>


                        <a target="_self" v-bind:href="'#/bilet/yeni/id?'+'isl=yeni'">
                            <v-btn flat> <span class="hidden-sm-and-down"> Yeni</span>
                                <v-icon right dark>add_box</v-icon>
                            </v-btn>
                        </a>
                        <v-menu bottom left>
                            <v-btn slot="activator" dark icon>
                                <v-icon>more_vert</v-icon>
                            </v-btn>
                            <v-list>

                                <v-list-tile @click.native="dialogcarikoddegistir=true">
                                    <v-list-tile-title>Cari Kod Değiştir</v-list-tile-title>
                                </v-list-tile>
                                <v-list-tile @click="gecicicariac()">
                                    <v-list-tile-title>Geçici Cari Kod Değiştir</v-list-tile-title>
                                </v-list-tile>




                            </v-list>
                        </v-menu>
                    </v-toolbar>
                </v-flex>
                <v-flex xs12 sm12>
                    <v-form ref="formbiletrapor" v-model="valid" lazy-validation>
                        <v-container fluid="">
                            <v-layout row wrap="">
                                <v-flex xs12 sm4 md2>
                                   <tarihim :etiket="'Başlangıç Tarihi'" :detaygizle="false" v-model="date"
                                        v-bind:defaultvalue="'ok'" :rules="[v => !!v || 'Lütfen tarih seçiniz']"></tarihim>
                                </v-flex>
                                <v-flex xs12 sm4 md2>
                                    <tarihim :etiket="'Bitiş Tarihi'" :detaygizle="false" v-model="date2"
                                        v-bind:defaultvalue="'ok'" :rules="[v => !!v || 'Lütfen tarih seçiniz']"></tarihim>
                                </v-flex>
                                <v-flex xs12 sm4 md2>
                                    <v-layout>
                                        <div v-if="load1">
                                            <v-btn color="info" @click="BiletListele(1,'SalesDate',50,false)" fab small=""
                                                dark>

                                                <v-icon>search</v-icon>
                                            </v-btn>
                                        </div>
                                        <div v-if="!load1">
                                            <v-layout fill-height="" align-center="">
                                                <v-progress-circular indeterminate color="primary"></v-progress-circular>
                                            </v-layout>
                                        </div>

                                        <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"
                                            @click="filtrele()" color="info" fab dark>
                                            <v-icon>filter_list</v-icon>
                                        </v-btn>
                                        <v-tooltip bottom="" :activator="el" v-model="tooltip">
                                            <span>Arama Filtresi Ekle</span>
                                        </v-tooltip>
                                    </v-layout>
                                </v-flex>

                                <!-- <v-flex xs12 sm12 md6>
                                    <v-layout justify-end="" fill-height="" row="" align-center="">

                                        <v-btn-toggle v-model="gorunumtipi">

                                            <v-btn flat value="list">
                                                <span>Liste</span>
                                                <v-icon>view_list</v-icon>
                                            </v-btn>
                                            <v-btn flat value="table">
                                                <span>Tablo</span>
                                                <v-icon>table_chart</v-icon>
                                            </v-btn>
                                        </v-btn-toggle>

                                    </v-layout>
                                </v-flex> -->

                            </v-layout>
                        </v-container>
                    </v-form>
                </v-flex>
                <!-- <v-flex xs12 sm12 v-if="tablegorunum">
                    <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="itemsticket"
                        :search="search1">
                        <v-progress-linear slot="progress" indeterminate></v-progress-linear>
                        <template slot="items" slot-scope="props">
                            <tr @click="git(props.item)" item>
                                <td class="text-xs-left">{{ props.item.GenelBilgileri.HavaYoluKodu }}</td>
                                <td class="text-xs-left">{{ props.item.GenelBilgileri.BiletNo }}</td>
                                <td class="text-xs-left">{{ props.item.GenelBilgileri.UcusTipi }}</td>
                                <td class="text-xs-left">{{ props.item.GenelBilgileri.Status}}</td>
                                <td class="text-xs-left">{{ props.item.GenelBilgileri.MusteriKodu.Kod }}</td>
                                <td class="text-xs-left">{{ props.item.GenelBilgileri.MusteriKodu.EFaturaKayitliList}}</td>
                                <td class="text-xs-left">{{ props.item.GenelBilgileri.MusteriKodu.FaturaTip }}</td>
                                <td class="text-xs-left">{{ props.item.FaturaBilgileri.FaturaSeri }}</td>
                                <td class="text-xs-left">{{ props.item.FaturaBilgileri.FaturaNo }}</td>
                                <td class="text-xs-left">{{ props.item.OdemeBilgileri.KrediKartBilgi.KrediKartTip }}</td>
                                <td class="text-xs-left">{{ props.item.TarihBilgileri.SatisTarihi }}</td>
                                <td class="text-xs-left">{{ props.item.FaturaBilgileri.FaturaTarihi }}</td>
                                <td class="text-xs-left">{{ props.item.TutarBilgileri.NetTutar.NetTutar }}</td>
                                <td class="text-xs-left">{{ props.item.TutarBilgileri.Tutar.Tutar }}</td>
                                <td class="text-xs-left">{{ props.item.TarihBilgileri.IadeTarihi }}</td>
                                <td class="text-xs-left">{{ props.item.Id }}</td>
                                <td class="text-xs-left">{{ props.item.TutarBilgileri.CezaTutar.CezaTutar }}</td>
                                <td class="text-xs-left">{{ props.item.GenelBilgileri.ExBiletNo }}</td>
                                <td class="text-xs-left">{{ props.item.GenelBilgileri.Acente }}</td>
                                <td class="text-xs-left">{{ props.item.OdemeBilgileri.KrediKartBilgi.KrediKartTip }}</td>
                                <td class="text-xs-left">{{ props.item.TutarBilgileri.ServisTutar.ServisTutar
                                    }}</td>
                            </tr>
                        </template>
                        <v-alert slot="no-results" :value="true" color="error" icon="warning">
                            Aradığınız "{{ search1 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
                        </v-alert>
                    </v-data-table>
                </v-flex> -->


                <v-dialog v-model="dialogfiltre" scrollable="" max-width="550px">
                    <v-card color="grey lighten-5">

                        <v-card-title>Filtre Seçimi</v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>

                            <v-flex xs12 sm12 md12 style=" padding-bottom:10px;">
                                <v-card class="white--text">
                                    <v-card color="grey lighten-5" flat="">
                                        <v-card-actions>

                                            <v-layout row="" wrap="">
                                                 <v-flex xs12 sm12 md12>
                                               <v-text-field hide-details="" autofocus="" v-model="ListInput.BiletNo" mask="##########"  label="Bilet Numarası">
    </v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm12 md12>
                                                    <v-autocomplete hide-details clearable="" label="Cari Kod"
                                                        append-icon="search" autocomplete :loading="loading" v-model="ListInput.Filtreler.CariKod"
                                                        :items="statecari" item-text="text" cache-items="" item-value="id"
                                                        :search-input.sync="searchcari"></v-autocomplete>
                                                </v-flex>
                                                <v-flex xs12 sm12 md12>
                                                    <v-autocomplete hide-details="" clearable :items="itemsairlinelist"
                                                        label="Havayolu Seçimi" multiple item-text="HavaYoluTitle"
                                                        v-model="ListInput.Filtreler.Havayollari" item-value="HavaYoluKodu">
                                                        <template slot="selection" slot-scope="{ item, index }">
                                                            <div v-if="index === 0">
                                                                <span>{{ item.HavaYoluAdi }}</span>
                                                            </div>
                                                            <span v-if="index === 1" class="grey--text caption">(+{{
                                                                ListInput.Filtreler.Havayollari.length -
                                                                1
                                                                }} diğer)</span>
                                                        </template>
                                                    </v-autocomplete>
                                                </v-flex>
                                                <v-layout row="" wrap="">
                                                    <v-flex xs12 sm6 md6>
                                                        <v-layout justify-space-between column>
                                                            <v-select hide-details="" clearable="" :items="itemsyon"
                                                                label="Yön Seçimi" multiple item-text="text" v-model="ListInput.Filtreler.HatTipi"
                                                                item-value="value">
                                                                <template slot="selection" slot-scope="{ item, index }">
                                                                    <div v-if="index === 0">
                                                                        <span>{{ item.text }}</span>
                                                                    </div>
                                                                    <span v-if="index === 1" class="grey--text caption">(+{{
                                                                        ListInput.Filtreler.HatTipi.length -
                                                                        1
                                                                        }} diğer)</span>
                                                                </template>
                                                            </v-select>
                                                        </v-layout>
                                                    </v-flex>
                                                    <v-flex xs12 sm6>
                                                        <v-select hide-details="" clearable="" :items="itemstip" label="Bilet Tipi"
                                                            item-text="text" v-model="ListInput.Filtreler.BiletTipi"
                                                            item-value="value">
                                                        </v-select>
                                                    </v-flex>
                                                </v-layout>
                                                <v-flex xs12 sm12>
                                                    <v-autocomplete hide-details="" clearable :items="itemsparkur"
                                                        label="Parkur Seçimi" multiple item-text="Title" v-model="ListInput.Filtreler.Parkurlar"
                                                        item-value="ParkurKod">
                                                        <template slot="selection" slot-scope="{ item, index }">
                                                            <div v-if="index === 0">
                                                                <span>{{ item.Aciklama }}</span>
                                                            </div>
                                                            <span v-if="index === 1" class="grey--text caption">(+{{
                                                                ListInput.Filtreler.Parkurlar.length -
                                                                1
                                                                }} diğer)</span>
                                                        </template>
                                                    </v-autocomplete>
                                                </v-flex>
                                                <v-layout>
                                                    <v-flex xs12 sm6>
                                                        <v-autocomplete clearable :items="itemsparkur" hide-details=""
                                                            label="Uçuş Kalkış" item-text="Title" v-model="ListInput.Filtreler.Ucus1"
                                                            item-value="ParkurKod">
                                                        </v-autocomplete>
                                                    </v-flex>
                                                    <v-flex xs12 sm6>
                                                        <v-autocomplete clearable :items="itemsparkur" hide-details=""
                                                            label="Uçuş Varış" item-text="Title" v-model="ListInput.Filtreler.Ucus2"
                                                            item-value="ParkurKod">
                                                        </v-autocomplete>
                                                    </v-flex>

                                                </v-layout>
                                                <v-flex xs12 sm12>
                                                    <v-text-field label="Kesen Kişi" hide-details="" v-model="ListInput.Filtreler.KesenKisi"></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <v-autocomplete :items="bankapositems" hide-datails tabindex="57"
                                                        hide-details="" v-model="ListInput.Filtreler.PosKod" item-text="Aciklama"
                                                        item-value="PosKodu" clearable label="Pos Seçim"></v-autocomplete>
                                                </v-flex>
                                                <v-flex xs12 sm6>
                                                    <kredikartcomp :tabdeger="'63'" v-model="ListInput.Filtreler.KrediKartNo"></kredikartcomp>
                                                </v-flex>
                                                <v-flex pa-1 xs12 sm12 md12>
                                                    <v-card flat="" color="#9E9E9E">
                                                        <v-card-title>
                                                            <span class="subheading white--text font-weight-medium ">Opsiyonlar</span>
                                                        </v-card-title>
                                                    </v-card>
                                                </v-flex>


                                                <div class="flex md6">
                                                    <v-radio-group v-model="ListInput.Filtreler.GiderPusulasi" label="Bilet Tipi"
                                                        hide-details>
                                                        <v-radio :value="0" label="Seçim Yok"></v-radio>
                                                        <v-radio :value="1" label="Gider Pusulası Basılmış"></v-radio>
                                                        <v-radio :value="2" label="Gider Pusulası Basılmamış"></v-radio>
                                                    </v-radio-group>
                                                </div>

                                                <div class="flex md6">
                                                    <v-radio-group v-model="ListInput.Filtreler.AcentaFatNo" label="Acenta Bileti İçin"
                                                        hide-details>
                                                        <v-radio :value="0" label="Seçim Yok"></v-radio>
                                                        <v-radio :value="1" label="Gelen Faturası Olan"></v-radio>
                                                        <v-radio :value="2" label="Gelen Faturası Olmayan"></v-radio>
                                                    </v-radio-group>
                                                </div>
                                                <div class="flex md6">
                                                    <v-radio-group v-model="ListInput.Filtreler.FaturaStatus" label="Fatura Tipi"
                                                        hide-details>
                                                        <v-radio :value="0" label="Seçim Yok"></v-radio>
                                                        <v-radio :value="1" label="Faturalanmamışlar"></v-radio>
                                                        <v-radio :value="2" label="Faturalanmışlar"></v-radio>
                                                    </v-radio-group>
                                                </div>

                                                <div class="flex md6">
                                                    <v-radio-group v-model="ListInput.Filtreler.GeciciCari" label="Cari Tipi"
                                                        hide-details>
                                                        <v-radio :value="0" label="Seçim Yok"></v-radio>
                                                        <v-radio :value="1" label="Geçici Cariler Hariç"></v-radio>
                                                        <v-radio :value="2" label="Sadece Geçici Cariler"></v-radio>
                                                    </v-radio-group>
                                                </div>
                                                <div class="flex md12">
                                                    <v-checkbox v-model="ListInput.Filtreler.IadeFatura" label="İade Faturası Gelmeyenleri Göster"
                                                        hide-details=""></v-checkbox>
                                                </div>
                                            </v-layout>
                                        </v-card-actions>
                                    </v-card>
                                </v-card>
                            </v-flex>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                               <v-btn color="blue darken-1" flat @click.native="dialogfiltre=false">İptal</v-btn>
                            <v-btn color="blue darken-1" flat @click="filtreiptal()">Filtreleri Temizle</v-btn>
                            <v-btn color="blue darken-1" flat @click.native="filtrekayit()">Fİltrelerİ Uygula</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <v-dialog v-model="dialogcarikoddegistir" scrollable="" persistent="" max-width="500px">
                    <v-card color="grey lighten-5">

                        <v-card-title>Cari Kod Değiştir</v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>

                            <v-layout row="" wrap="">
                                <v-flex xs12 sm12 md12>
                                    <v-autocomplete hide-details clearable="" label="Cari Seçiniz" append-icon="search"
                                        autocomplete :loading="loading" :items="statecariyeni" item-text="text"
                                        cache-items="" v-model="yenicari" item-value="id" :search-input.sync="yenicarisearch"></v-autocomplete>
                                </v-flex>


                            </v-layout>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" flat @click.native="dialogcarikoddegistir=false">İptal</v-btn>
                            <v-btn color="blue darken-1" flat @click.native="carisor()">Cari Kod Değiştir</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="gecicicaridialog" scrollable="" max-width="500px">
                    <v-card color="grey lighten-5">

                        <v-card-title>Geçici Hesaptaki Biletleri Cariye Aktarma</v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <v-flex pa-1 xs12 sm12 md12>
                                <v-card class="white--text">
                                    <v-card color="grey lighten-4" flat="">
                                        <v-card-actions>
                                            <v-layout row wrap>
                                                <v-flex xs12 sm12 md12>

                                                    <v-autocomplete hide-details clearable="" label="Cari Seçiniz"
                                                        append-icon="search" autocomplete :loading="loadinggecici"
                                                        :items="statecarigecic" item-text="text" cache-items="" v-model="geciciyenicari"
                                                        item-value="id" :search-input.sync="yenicarigecicisearch"></v-autocomplete>
                                                </v-flex>
                                                <v-flex xs12 sm12 md12>

                                                    <v-text-field label="Kesen Kişi" v-model="GeciciCari.KesenKisi"
                                                        hide-details=""></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>

                                                    <masrafmerkezicomp v-model="GeciciCari.Masraf" :etiket="'Masraf Merkezi'"></masrafmerkezicomp>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>

                                                    <referansmerkezicomp v-model="GeciciCari.Referans" :etiket="'Referans Merkezi'"></referansmerkezicomp>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
                                                    <v-text-field label="Rez. Veren" v-model="GeciciCari.RezervasyonVeren"
                                                        hide-details=""></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
                                                    <v-text-field label="Rez Alan" v-model="GeciciCari.RezervasyonAlan"
                                                        hide-details=""></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm12 md12>

                                                    <v-select hide-details="" v-model="GeciciCari.SatisSekli" :items="satissekliitem"
                                                        item-text="text" item-value="value" clearable label=" Satış Şekli"></v-select>
                                                </v-flex>
                                                <div v-if="kredikartshow">

                                                    <v-layout row wrap>
                                                        <v-flex xs12 sm6 md6>
                                                            <kredikartcomp :tabdeger="'63'" v-model="GeciciCari.KrediKartNo"></kredikartcomp>
                                                        </v-flex>
                                                        <v-flex xs12 sm6 md6>
                                                            <v-select :items="karttipi" hide-details="" v-model="GeciciCari.KKCins"
                                                                clearable label="Kredi Kartı Tipi" item-text="text"
                                                                item-value="id"></v-select>
                                                        </v-flex>
                                                    </v-layout>

                                                    <v-layout row wrap>
                                                        <v-flex xs12 sm6 md6>

                                                            <v-select hide-details="" :items="sonkullanimAy" v-model="GeciciCari.KKAy"
                                                                clearable label="Son Kullanım Ay" item-text="text"
                                                                item-value="id"></v-select>

                                                        </v-flex>
                                                        <v-flex xs12 sm6 md6>
                                                            <v-select hide-details="" :items="sonkullanimYil" clearable
                                                                v-model="GeciciCari.KKYil" label="Son Kullanım Yıl"
                                                                item-text="text" item-value="id"></v-select>
                                                        </v-flex>
                                                    </v-layout>
                                                </div>
                                                <v-layout v-show="bankaposshow">
                                                    <v-flex xs12 sm6 md6>
                                                        <v-autocomplete :items="bankapositems" hide-details="" v-model="GeciciCari.PosKod"
                                                            @change="taksitgetir(GeciciCari.PosKod)" item-text="Aciklama"
                                                            item-value="PosKodu" clearable label="Pos Kodu"></v-autocomplete>
                                                    </v-flex>
                                                    <v-flex xs12 sm6 md6>
                                                        <v-select :items="taksitsayi" hide-details="" v-model="GeciciCari.TaksitKod"
                                                            item-text="TaksitAciklama" item-value="TaksitID" clearable
                                                            label="Taksit"></v-select>
                                                    </v-flex>
                                                </v-layout>


                                                <v-layout v-show="servisposshow">
                                                    <v-flex xs12 sm6 md6>

                                                        <v-autocomplete :items="bankapositems" hide-details="" @change="taksitgetirservis(GeciciCari.ServisPosKod)"
                                                            v-model="GeciciCari.ServisPosKod" item-text="Aciklama"
                                                            item-value="PosKodu" clearable label="Servis Pos Kodu"></v-autocomplete>
                                                    </v-flex>
                                                    <v-flex xs12 sm6 md6>

                                                        <v-select :items="taksitsayiservis" hide-details="" v-model="GeciciCari.ServisTaksitKod"
                                                            item-text="TaksitAciklama" item-value="TaksitID" clearable
                                                            label="Taksit"></v-select>
                                                    </v-flex>
                                                </v-layout>
                                                <v-flex xs12 sm12 md12>

                                                    <parainput :etiket="'Servis Tutar'" v-model="GeciciCari.ServisTutar"
                                                        :autocomplete="'autocomplete'"></parainput>
                                                </v-flex>
                                                <v-flex xs12 sm12 md12>

                                                    <parainput :etiket="'Diğer Servis Tutar'" v-model="GeciciCari.DigerServisTutar"
                                                        :autocomplete="'autocomplete'"></parainput>
                                                </v-flex>
                                                <v-flex xs12 sm12 md12>
                                                    <parainput :etiket="'İskonto Tutar'" v-model="GeciciCari.IskontoTutar"
                                                        :autocomplete="'autocomplete'"></parainput>
                                                </v-flex>
 <parainput :etiket="RezTutarEtiket"  v-model="GeciciCari.ReserveTutar"
                                    :autocomplete="'autocomplete'"></parainput>

                                                <v-flex xs12 sm12 md12>
                                                    <parainput :etiket="'HY Tutar'" v-model="GeciciCari.HYTutar"
                                                        :autocomplete="'autocomplete'"></parainput>
                                                </v-flex>
                                                <v-flex xs12 sm12 md12>
                                                    <v-select hide-details="" v-model="GeciciCari.DovizTipi" :items="doviztipi"
                                                        clearable item-text="DovizUnvan" item-value="DovizKod" label="Döviz Tipi"></v-select>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
                                                    <bolumcomp v-model="GeciciCari.BolumKodu" :etiket="'Bölüm Kodu'"></bolumcomp>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
                                                    <v-text-field v-model="GeciciCari.GSM" label="GSM" hide-details=""></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm12 md12>
                                                    <tarihim :v-bind="GeciciCari.DateofRes" v-model="GeciciCari.DateofRes"
                                                        :etiket="'Rez. Tarihi'"></tarihim>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>

                                                    <analizcomp v-model="GeciciCari.AnalizKodu" :etiket="'Analiz1'"></analizcomp>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
                                                    <parainput :etiket="'Analiz1 Tutar'" v-model="GeciciCari.AnalizTutar"
                                                        :autocomplete="'autocomplete'"></parainput>
                                                </v-flex>

                                                <v-flex xs12 sm6 md6>
                                                    <analizcomp v-model="GeciciCari.AnalizKodu1" :etiket="'Analiz2'"></analizcomp>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
                                                    <parainput :etiket="'Analiz2 Tutar'" v-model="GeciciCari.AnalizTutar1"
                                                        :autocomplete="'autocomplete'"></parainput>
                                                </v-flex>

                                            </v-layout>
                                        </v-card-actions>
                                    </v-card>
                                </v-card>
                            </v-flex>

                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" flat @click.native="gecicicaridialog=false">İptal</v-btn>
                            <v-btn color="blue darken-1" flat @click="gecicicarisor()">Geçici Cari Değiştir</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>


            </v-layout>
        </v-card>

        <v-layout row="" wrap v-if="listegorunum">

            <v-flex xs12 sm12 md12>
                <v-card color="grey lighten-5">
                    <v-flex xs12 sm12 md12>
                        <v-layout row wrap>
                            <v-flex xs12 sm12 md9>
                                <v-layout align-center="" fill-height="">
                                    <div class=" font-weight-large grey--text title ">
                                        &nbsp; {{recordcount}} <span v-if="secilenkayitlar.length>0" class=" font-weight-large red--text title ">
                                            {{secilenkayitlar.length}} kayıt seçildi.. </span>
                                    </div>
                                </v-layout>
                            </v-flex>
                            <v-flex v-show="kayitvarmi" xs12 sm12 md2>
                                <v-select hide-details="" :items="siralamatipiitems" color="grey darken-1" v-model="siralamatipi"
                                    item-text="text" item-value="value" label="Sıralama Tipi"></v-select>
                            </v-flex>
                            <v-flex v-show="kayitvarmi" xs12 sm12 md1>
                                <v-select hide-details="" :items="kayitsayisi" color="grey darken-1" v-model="kayitadet"
                                    item-text="text" item-value="value" label="Göster"></v-select>
                            </v-flex>
                        </v-layout>

                        <v-layout>
                                <v-list-tile>
                                    <v-list-tile-content>
                                        <v-layout v-if="kayitvarmi" justify-center="" align-center>
                                            <v-checkbox v-model="tumunuseckaldir" label="Tümünü Seç"></v-checkbox>
                                        </v-layout>
                                    </v-list-tile-content>
                                </v-list-tile>
                        </v-layout>
                    </v-flex>

                    <v-list two-line>
                        <template v-for="item in filtreticket">
                            <v-layout row wrap v-bind:key="item.GenelBilgileri.BiletNo">
                                <v-card flat="">
                                    <v-list-tile>
                                        <v-list-tile-content>
                                            <v-layout justify-center="" align-center>
                                                <v-checkbox hide-details="" v-model="secilenkayitlar" :value="item"></v-checkbox>
                                            </v-layout>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                </v-card>
                                <v-flex sm12 md1>
                                    <v-card flat="">
                                        <v-list-tile>
                                            <v-list-tile-content>
                                                <v-img :src="getImgUrl(item.GenelBilgileri.HavaYoluKodu)" height="60%"
                                                    width="60%" contain></v-img>
                                                <v-img v-if="item.GenelBilgileri.Acente =='A'" :src="getImgUrl(item.GenelBilgileri.HavaYoluKodu)"
                                                    alt="K" height="21px" width="86px" contain></v-img>
                                                <!-- <v-flex xs5>
                                            <v-img
                                                :src="require(`@/assets/airlinelogo/${item.GenelBilgileri.HavaYoluKodu }`+`.png`)"  height="21px"
                                                width="86px" contain></v-img>
                                            </v-flex> -->

                                                <!-- <v-list-tile-avatar>
                                            <img :src="require(`@/assets/airlinelogo/${item.GenelBilgileri.HavaYoluKodu }`+`.png`)">

                                            </v-list-tile-avatar> -->

                                            </v-list-tile-content>
                                        </v-list-tile>
                                    </v-card>
                                </v-flex>

                                <v-flex xs12 sm4 md2>
                                    <v-layout align-start justify-start row fill-height>
                                        <v-card flat="">
                                            <v-list-tile>
                                                <v-list-tile-content>
                                                    <v-layout row align-center justify-start>
                                                        <v-chip v-if="item.GenelBilgileri.Status=='S' " small="" color="green"
                                                            text-color="white">Satış</v-chip>
                                                        <v-chip v-if="item.GenelBilgileri.Status=='Ia' " small="" color="red"
                                                            text-color="white">İade</v-chip>
                                                        <v-chip v-if="item.GenelBilgileri.Status=='V' " small="" color="yellow"
                                                            text-color="white">Void</v-chip>
                                                        <v-list-tile-title> <span class='grey-text--primary caption '>
                                                                {{item.GenelBilgileri.HavaYoluKodu}} -
                                                                {{item.GenelBilgileri.BiletNo}} -
                                                                {{item.GenelBilgileri.UcusTipi}} </span>
                                                        </v-list-tile-title>
                                                    </v-layout>
                                                    <v-list-tile-sub-title> &nbsp; <span class='grey-text--primary caption '>
                                                            {{item.GenelBilgileri.YolcuAdi}}</span>
                                                    </v-list-tile-sub-title>
                                                    <v-list-tile-sub-title> &nbsp; <span class='grey-text--primary caption '>
                                                            {{item.GenelBilgileri.MusteriKodu.Kod}}
                                                            -{{item.GenelBilgileri.MusteriKodu.Unvan}} </span>
                                                    </v-list-tile-sub-title>
                                                </v-list-tile-content>
                                            </v-list-tile>
                                        </v-card>
                                    </v-layout>
                                </v-flex>

                                <v-flex xs12 sm4 md2>
                                    <v-layout align-start justify-start row fill-height>
                                        <v-card flat="">
                                            <v-list-tile>
                                                <v-list-tile-content>
                                                    <v-layout row wrap align-center="" justify-start>
                                                        <v-list-tile-title>
                                                            <div class="font-weight-large red--text title">
                                                                {{item.TarihBilgileri.SatisTarihi}}</div>
                                                        </v-list-tile-title>
                                                        <v-list-tile-sub-title v-if="item.GenelBilgileri.Status=='Ia'">
                                                            <div class="font-weight-large grey--text caption">
                                                                İade Tarihi: <span class="font-weight-large red--text caption">

                                                                    {{item.TarihBilgileri.IadeTarihi}} </span>
                                                            </div>
                                                        </v-list-tile-sub-title>
                                                        <v-list-tile-sub-title v-if="item.GenelBilgileri.Status=='V'">
                                                            <div class="font-weight-large grey--text caption ">
                                                                Void Tarihi:<span class="font-weight-large red--text caption">
                                                                    {{item.TarihBilgileri.IptalTarihi}} </span>
                                                            </div>
                                                        </v-list-tile-sub-title>
                                                    </v-layout>
                                                </v-list-tile-content>
                                            </v-list-tile>
                                        </v-card>
                                    </v-layout>
                                </v-flex>

                                <v-flex class="hidden-md-and-up" xs2 sm2 md2>
                                </v-flex>

                                <v-flex xs12 sm4 md2>
                                    <v-layout row wrap>
                                        <v-flex xs12 sm12 md12>
                                            <v-layout align-start="" justify-start fill-height>
                                                <v-card flat="">
                                                    <v-list-tile>
                                                        <v-list-tile-content style="'overflow=inherit';">
                                                            <v-list-tile-sub-title>
                                                                <div class="font-weight caption "> Fatura Tarihi:
                                                                    {{item.FaturaBilgileri.FaturaTarihi}} </div>
                                                            </v-list-tile-sub-title>

                                                            <v-list-tile-sub-title>
                                                                <div class="font-weight caption "> Fatura No:
                                                                    {{item.FaturaBilgileri.FaturaNo}}
                                                                </div>
                                                            </v-list-tile-sub-title>
                                                            <v-list-tile-sub-title>
                                                                <div v-if="item.FaturaBilgileri.FaturaDurumu=='Fatura Beklemede'"
                                                                    class="font-weight caption ">
                                                                    <v-icon hide-details color="yellow" small="">access_alarm</v-icon>
                                                                    {{item.FaturaBilgileri.FaturaDurumu}}
                                                                </div>

                                                                <div v-if="item.FaturaBilgileri.FaturaDurumu=='Alıcı Onayladı'"
                                                                    class="font-weight caption ">
                                                                    <v-icon hide-details color="green" small="">check_box</v-icon>
                                                                    {{item.FaturaBilgileri.FaturaDurumu}}
                                                                </div>

                                                                <div v-if="item.FaturaBilgileri.FaturaDurumu=='Fatura Gönderildi'"
                                                                    class="font-weight caption ">
                                                                    <v-icon hide-details color="red" small="">send</v-icon>
                                                                    {{item.FaturaBilgileri.FaturaDurumu}}
                                                                </div>

                                                            </v-list-tile-sub-title>


                                                        </v-list-tile-content>
                                                    </v-list-tile>
                                                </v-card>
                                            </v-layout>
                                        </v-flex>

                                    </v-layout>
                                </v-flex>


                                <v-flex xs12 sm4 md2>
                                    <v-layout>

                                        <v-flex xs12 sm6 md6>
                                            <v-layout align-start="" justify-start fill-height>
                                                <v-card flat="">
                                                    <v-list-tile>
                                                        <v-list-tile-content style="'overflow=inherit';">
                                                            <v-list-tile-sub-title>
                                                                <div class="font-weight caption ">
                                                                    Bilet Tutarı:
                                                                </div>
                                                            </v-list-tile-sub-title>
                                                            <v-list-tile-sub-title>
                                                                <div class="font-weight caption ">
                                                                    Vergiler:
                                                                </div>
                                                            </v-list-tile-sub-title>
                                                            <v-list-tile-sub-title>
                                                                <div class="font-weight caption ">
                                                                    Servis Bedeli:
                                                                </div>
                                                            </v-list-tile-sub-title>
                                                            <v-list-tile-sub-title>
                                                                <div class="font-weight caption ">

                                                                </div>
                                                            </v-list-tile-sub-title>

                                                        </v-list-tile-content>
                                                    </v-list-tile>
                                                </v-card>
                                            </v-layout>
                                        </v-flex>

                                        <v-flex xs12 sm6 md6>
                                            <v-layout row justify-end="" fill-height>
                                                <v-card flat="">
                                                    <v-list-tile>
                                                        <v-list-tile-content>
                                                            <v-list-tile-sub-title>
                                                                <v-layout align-center="" justify-end>
                                                                    <div class="font-weight caption ">
                                                                        {{item.TutarBilgileri.Tutar.Tutar}} ₺ </div>
                                                                </v-layout>
                                                            </v-list-tile-sub-title>
                                                            <v-list-tile-sub-title>
                                                                <v-layout align-center="" justify-end="">
                                                                    <div class="font-weight caption ">
                                                                        {{item.TutarBilgileri.Vergiler}} ₺
                                                                    </div>
                                                                </v-layout>
                                                            </v-list-tile-sub-title>
                                                            <v-list-tile-sub-title>
                                                                <v-layout align-center="" justify-end="">
                                                                    <div class="font-weight caption ">
                                                                        {{item.TutarBilgileri.ServisBedeli}}
                                                                        ₺
                                                                    </div>
                                                                </v-layout>
                                                            </v-list-tile-sub-title>
                                                            <v-list-tile-sub-title>
                                                                <v-layout align-center="">
                                                                    <div class="font-weight caption ">

                                                                    </div>
                                                                </v-layout>
                                                            </v-list-tile-sub-title>
                                                        </v-list-tile-content>
                                                    </v-list-tile>
                                                </v-card>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>

                                <!-- <v-flex class="hidden-md-and-up" xs1 sm1 md1>
                                </v-flex> -->

                                <v-flex xs12 sm4 md1>
                                    <v-layout row align-center justify-center="" fill-height="">
                                        <v-card flat="">
                                            <v-list-tile>
                                                <v-list-tile-content>
                                                    <v-layout row wrap justify-center="">
                                                        <v-list-tile-title>
                                                            <v-layout row wrap justify-center="">
                                                                Net Tutar
                                                            </v-layout>
                                                        </v-list-tile-title>
                                                        <v-list-tile-sub-title>
                                                            <v-layout row wrap justify-end="">
                                                                <div class="red--text subheading">
                                                                    {{item.TutarBilgileri.NetTutar.NetTutar }} ₺ </div>
                                                            </v-layout>
                                                            <!-- <v-tooltip bottom="" :activator="eltutar" v-model="tooltiptutar">
                                            <span>{{item.OdemeBilgileri.ServisBedeli}}</span>
                                            <span>Tutar Bedeli: 10 ₺</span>
                                            <span>Tutar Bedeli: 10 ₺</span><span>Tutar Bedeli: 10 ₺</span><span>Tutar Bedeli: 10 ₺</span><span>Tutar Bedeli: 10 ₺</span>
                                        </v-tooltip> -->
                                                        </v-list-tile-sub-title>
                                                        <v-list-tile-title>
                                                            <v-layout row wrap justify-center="">
                                                                <div class="font-weight green--text caption ">
                                                                    {{item.OdemeBilgileri.SatisSekli}}
                                                                </div>
                                                            </v-layout>

                                                        </v-list-tile-title>
                                                    </v-layout>
                                                </v-list-tile-content>

                                            </v-list-tile>
                                        </v-card>
                                    </v-layout>
                                </v-flex>

                                <v-flex sm4 md1>

                                    <v-layout row align-center justify-end="">
                                        <v-card flat="">
                                            <v-list-tile>

                                                <v-list-tile-action>
                                                    <v-layout align-center="" fill-height="" justify-end>
                                                        <v-flex sm6 md6>
                                                            <a v-if="item.GenelBilgileri.Status!='V'" target="_blank"
                                                                v-bind:href="'#/bilet/yeni/id?' + 'isl=get&hyolukod=' + item.GenelBilgileri.HavaYoluKodu + '&biletno=' + item.GenelBilgileri.BiletNo + '&ucustipi=' + item.GenelBilgileri.UcusTipi">
                                                                <v-btn icon>
                                                                    <v-icon x-large="" color="grey">search</v-icon>
                                                                </v-btn>
                                                            </a>

                                                            <a v-if="item.GenelBilgileri.Status=='V'" target="_blank"
                                                                v-bind:href="'#/bilet/yeni/id?' + 'isl=voidget&hyolukod=' + item.GenelBilgileri.HavaYoluKodu + '&biletno=' + item.GenelBilgileri.BiletNo + '&ucustipi=' + item.GenelBilgileri.UcusTipi">
                                                                <v-btn icon>
                                                                    <v-icon x-large="" color="grey">search</v-icon>
                                                                </v-btn>
                                                            </a>
                                                        </v-flex>

                                                    </v-layout>

                                                </v-list-tile-action>
                                            </v-list-tile>
                                        </v-card>
                                    </v-layout>

                                </v-flex>

                            </v-layout>
                            <v-divider :key="item.id" inset></v-divider>
                        </template>
                    </v-list>

                </v-card>
            </v-flex>
        </v-layout>


        <v-dialog v-model="caridialog" width="500">
            <v-card>
                <v-flex xs12 sm12>
                    <v-toolbar size="120px" dark color="info">
                        <v-toolbar-title class="baslikfont">Dikkat!</v-toolbar-title>
                    </v-toolbar>
                </v-flex>

                <v-card-text>
                    {{secilenkayitlar.length}} {{dialogmesaj}}
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click.native="caridialog=false">
                        İptal
                    </v-btn>
                    <v-btn color="primary" flat @click="carikoddegistir()">
                        Evet
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="gecicicaridialogsor" width="500">
            <v-card>
                <v-flex xs12 sm12>
                    <v-toolbar size="120px" dark color="info">
                        <v-toolbar-title class="baslikfont">Dikkat!</v-toolbar-title>
                    </v-toolbar>
                </v-flex>

                <v-card-text>
                    {{secilenkayitlar.length}} {{dialogmesajgecici}}
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click.native="gecicicaridialogsor=false">
                        İptal
                    </v-btn>
                    <v-btn color="primary" flat @click="gecicicarikoddegistir()">
                        Evet
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <template v-if="vmodelpagination">
            <div class="text-xs-center">
                <v-container>
                    <v-layout justify-center>
                        <v-flex xs8>
                            <v-pagination v-model="sayfalama" :length="pagenumber"></v-pagination>
                        </v-flex>
                    </v-layout>
                </v-container>
            </div>
        </template>

        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
            :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
        </v-snackbar>


    </div>
</template>

<script>
    import auth from '../../../api/auth'
    import kredikartcomp from "@/components/app/bilet/partpage/kredikartcomp.vue"
    import logoo from '../../../assets/control'
    import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"
    import masrafmerkezicomp from "@/components/app/bilet/partpage/masrafmerkezicomp.vue"
    import analizcomp from "@/components/app/bilet/partpage/analizcomp.vue"
    import parainput from "@/components/app/customcomp/parainput.vue"
    import bolumcomp from "@/components/app/bilet/partpage/bolumcomp.vue"
    import tarihim from "@/components/app/customcomp/tarihim.vue"
    import helpers from "@/components/app/customcomp/helpers.js"



    export default {
        data() {
            return {
                bankaposshow: false,
                servisposshow: false,
                bankapositems: [],
                taksitsayi: [],
                taksitsayiservis: [],
                kredikartshow: false,
                karttipi: [{
                        id: 'M',
                        text: 'Master Card'
                    },
                    {
                        id: 'VI',
                        text: 'VISA'
                    },
                    {
                        id: 'A',
                        text: 'American Express'
                    },
                ],
                sonkullanimAy: [{
                        id: '01',
                        text: '1'
                    },
                    {
                        id: '02',
                        text: '2'
                    },
                    {
                        id: '03',
                        text: '3'
                    },
                    {
                        id: '04',
                        text: '4'
                    },
                    {
                        id: '05',
                        text: '5'
                    },
                    {
                        id: '06',
                        text: '6'
                    },
                    {
                        id: '07',
                        text: '7'
                    },
                    {
                        id: '08',
                        text: '8'
                    },
                    {
                        id: '09',
                        text: '9'
                    },
                    {
                        id: '10',
                        text: '10'
                    },
                    {
                        id: '11',
                        text: '11'
                    },
                    {
                        id: '12',
                        text: '12'
                    }
                ],
                sonkullanimYil: [
                    '2005', '2006', '2007', '2008', '2009', '2010', '2011', '2012', '2013', '2014', '2015', '2016',
                    '2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026', '2027', '2028',
                    '2029', '2030'
                ],
                dialogmesajgecici: null,
                gecicicaridialogsor: false,
                geciciyenicari: null,
                doviztipi: [],
                satissekliitem: [{
                    text: 'K-Kredili',
                    value: 'K'
                }, {
                    text: 'P-Peşin',
                    value: 'P'
                }, {
                    text: 'R-Kartlı',
                    value: 'R'
                }, {
                    text: 'C-Kartlı',
                    value: 'C'
                }, {
                    text: 'F-Kredi Kartlı',
                    value: 'F'
                }],
                statecarigecic: [],
                loadinggecici: false,
                yenicarigecici: null,
                yenicarigecicisearch: null,
                gecicicaridialog: false,
                nereden: 0,
                aramayapildi: false,
                kayitadet: 50,
                siralamatipi: 'SalesDate',
                kayitvarmi: false,
                caridialog: false,
                dialogmesaj: null,
                yedekListInput: null,
                tumunuseckaldir: false,
                statecariyeni: [],
                yenicari: null,
                yenicarisearch: null,
                dialogcarikoddegistir: false,
                secilenkayitlar: [],
                secilenkayitlaryedek: [],

                bankapositems: [],
                itemsparkur: [],
                itemsyon: [{
                    text: 'İç',
                    value: 'I'
                }, {
                    text: 'Dış',
                    value: 'D'
                }, {
                    text: 'BSP',
                    value: 'B'
                }],
                itemstip: [{
                        text: 'Satış',
                        value: 'S'
                    }, {
                        text: 'Iade',
                        value: 'I'
                    },
                    {
                        text: 'Void',
                        value: 'V'
                    }
                ],
                RezTutarEtiket:'Reserve Tutar',
                itemsairlinelist: [],
                ListInputYedek: [],
                ListInput: {
                    SirketKodu: null,
                    BaslangicTarihi: null,
                    BitisTarihi: null,
                    Carikod: null,
                    HavaYoluKodu: null,
                    FormNo: null,
                    BiletNo: null,
                    Paging: {
                        SayfaNo: null,
                        VeriAdet: 50,
                        SiralamaTip: 0
                    },
                    Filtreler: {
                        CariKod: null,
                        Havayollari: [],
                        Parkurlar: [],
                        HatTipi: [], // I : iç hat, D: Dış hat, B: Bsp
                        BiletTipi: null, // S: Satış, I: Iade, V : Void
                        Ucus1: null,
                        Ucus2: null,
                        KesenKisi: null,
                        PosKod: null,
                        KrediKartNo: null,
                        GiderPusulasi: 0, // 0: seçim yok, 1 : basılmış, 2 : basılmamış
                        AcentaFatNo: 0, // 0 : seçim yok, 1 : fatura olan, 2 : fatura olmayan
                        IadeFatura: false,
                        GeciciCari: 0, // 0 : hepsi, 1 : geci haric, 2 : sadece gecici
                        FaturaStatus: 0, // 0 : hepsi, 1 : faturalanmamışlar, 2 : faturalanmışlar
                    }
                },
                GeciciCari: {
                    KesenKisi: null,
                    Referans: null,
                    Masraf: null,
                    RezervasyonVeren: null,
                    RezervasyonAlan: null,
                    SatisSekli: 'K',
                    KrediKartNo: null,
                    KKCins: null,
                    KKAy: null,
                    KKYil: null,
                    ServisTutar: 0,
                    DigerServisTutar: 0,
                    IskontoTutar: 0,
                    HYTutar: 0,
                    PosKod: null,
                    TaksitKod: null,
                    ReserveTutar:0,
                    ServisPosKod: null,
                    ServisTaksitKod: null,
                    DovizTip: null,
                    BolumKodu: null,
                    GSM: null,
                    DateofRes: null, //date
                    AnalizKodu: null,
                    AnalizTutar: 0,
                    AnalizKodu1: null,
                    AnalizTutar1: 0,
                },

                Havayolu: {
                    HavaYoluKodu: null,
                    FormNo: null,
                    HavaYoluAdi: null
                    //devam eden class
                },
                searchliste: null,
                listegorunum: true,
                gorunumtipi: 'list',
                tablegorunum: false,
                kayitsayisivmodel: 50,
                kayitsayisi: [{
                    text: '50',
                    value: 50
                }, {
                    text: '100',
                    value: 100
                }],
                vmodelpagination: false,
                siralamavmodel: 0,
                siralamatipiitems: [{
                    text: 'Tarihe Göre Artan',
                    value: 'SalesDate'
                }, {
                    text: 'Tarihe Göre Azalan',
                    value: 'SalesDateDesc'
                }, {
                    text: 'Bilet No Artan',
                    value: 'TicketNumber'
                }, {
                    text: 'Bilet No Azalan',
                    value: 'TicketNumberDesc'
                }, {
                    text: 'Fatura Tarihi Artan',
                    value: 'InvoiceDate'
                }, {
                    text: 'Fatura Tarihi Azalan',
                    value: 'InvoiceDateDesc'
                }, {
                    text: 'Cari Kodu Artan',
                    value: 'CustomerCode'
                }, {
                    text: 'Cari Kodu Azalan',
                    value: 'CustomerCodeDesc'
                }, {
                    text: 'Fiyat Artan',
                    value: 'Price'
                }, {
                    text: 'Fiyat Azalan',
                    value: 'PriceDesc'
                }],

                recordcount: '',
                filtreticket: [],
                indexsayisi: 10,
                pagenumber: 1,
                sayfalama: null,
                search1: '',
                headers: [{
                        text: 'HY Kodu',
                        value: 'GenelBilgileri.HavaYoluKodu'
                    },
                    {
                        text: 'Bilet No ',
                        value: 'GenelBilgileri.BiletNo',
                    },
                    {
                        text: 'Tip',
                        value: 'GenelBilgileri.UcusTipi'
                    },
                    {
                        text: 'Durum',
                        value: 'GenelBilgileri.Status'
                    },
                    {
                        text: 'Müsteri Kodu',
                        value: 'GenelBilgileri.MusteriKodu.Kod'
                    },
                    {
                        text: 'Fatura Kayıtlı',
                        value: 'GenelBilgileri.MusteriKodu.EFaturaKayitliList'
                    },
                    {
                        text: 'Fatura Tip',
                        value: 'GenelBilgileri.MusteriKodu.FaturaTip'
                    },
                    {
                        text: 'Fatura Seri',
                        value: 'FaturaBilgileri.FaturaSeri'
                    },
                    {
                        text: 'Fatura No',
                        value: 'FaturaBilgileri.FaturaNo'
                    },
                    {
                        text: 'Satış Tip',
                        value: 'OdemeBilgileri.KrediKartBilgi.KrediKartTip'
                    },
                    {
                        text: 'Satış Tarihi',
                        value: 'TarihBilgileri.SatisTarihi'
                    },
                    {
                        text: 'Fatura Tarihi',
                        value: 'FaturaBilgileri.FaturaTarihi'
                    },
                    {
                        text: 'Net Tutar',
                        value: 'TutarBilgileri.NetTutar.NetTutar'
                    },
                    {
                        text: 'Satış Tutarı',
                        value: 'TutarBilgileri.Tutar.Tutar'
                    },
                    {
                        text: 'İade/Void Tarihi',
                        value: 'TarihBilgileri.IadeTarihi'
                    },
                    {
                        text: 'İade Tutarı',
                        value: 'Id'
                    },
                    {
                        text: 'Ceza',
                        value: 'TutarBilgileri.CezaTutar.CezaTutar'
                    },
                    {
                        text: 'Ex Bilet No',
                        value: 'GenelBilgileri.ExBiletNo'
                    },
                    {
                        text: 'Acente',
                        value: 'GenelBilgileri.Acente'
                    },
                    {
                        text: 'KK Tip',
                        value: 'OdemeBilgileri.KrediKartBilgi.KrediKartTip'
                    },
                    {
                        text: 'Servis',
                        value: 'TutarBilgileri.ServisTutar.ServisTutar'
                    }
                ],
                value: null,
                caridegeri: null,
                dialogfiltre: false,
                loading: false,
                statecari: [],
                searchcari: '',
                renk1: 'info',
                date: null,
                menu: false,
                modal: false,
                dateFormatted: '',
                date2: null,
                menu2: false,
                dateFormatted2: '',
                modal2: false,
                harekettipi: '',
                items: [],
                itemsticket: [],

                StartDate: null,
                EndDate: null,
                load: false,
                load1: true,
                dialogmessage: '',
                dialog: false,
                progress: false,
                valid: true,
                snackbar: false,
                y: 'top',
                x: 'right',
                mode: '',
                timeout: 6000,
                text1: '',
                tooltip: false,
                el: null,

                //  tooltiptutar: false,
                // eltutar: null,
            }
        },
        methods: {
            taksitgetir(v) {

                var tumliste = []
                tumliste = this.bankapositems

                tumliste.forEach(element => {

                    if (element.PosKodu == v) {

                        this.taksitsayi = []
                        this.taksitsayi = element.Taksitler

                    }
                });

            },
            taksitgetirservis(v) {

                var tumliste = []
                tumliste = this.bankapositems

                tumliste.forEach(element => {

                    if (element.PosKodu == v) {

                        this.taksitsayiservis = []
                        this.taksitsayiservis = element.Taksitler
                    }
                });
            },


            gecicicariac() {



                this.gecicicaridialog = true;


                var credentials = JSON.parse(window.localStorage.getItem('credentials'));

                var params1 = {
                    CompanyCode: credentials.SirketKodu
                }


    this.$http.post(auth.API_URL + 'api/TicketHelpers/GetReserveName', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.RezTutarEtiket = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-class'
        this.progress = false
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-class'
        this.progress = false
        this.snackbar = true
      }
    })


                this.$http.post(auth.API_URL + 'api/currency/List', params1, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {
                    this.doviztipi = response.body
                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable-Döviz'
                        this.snackbar = true
                    } else {
                        this.text1 = 'Service Unavailable-Döviz'
                        this.snackbar = true
                    }
                })




                this.$http.post(auth.API_URL + 'api/BankPos/List', params1, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {
                    this.bankapositems = response.body
                    this.progress = false
                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable-bankpos'
                        this.progress = false
                        this.snackbar = true
                    } else {
                        this.text1 = 'Service Unavailable-bankpos'
                        this.snackbar = true
                        this.progress = false
                    }
                })


            },
            carisor() {

                if (this.yenicari != null) {
                    if (this.secilenkayitlar.length > 0) {

                        this.caridialog = true;
                        this.dialogmesaj = " adet kaydın carisini değiştirmek istediğinize emin misiniz?";

                    } else {
                        this.text1 = 'Lütfen Bilet Seçimi Yapınız'
                        this.snackbar = true;
                    }

                } else {
                    this.text1 = 'Lütfen Cari Kod Seçimi Yapınız1'
                    this.snackbar = true;
                }


            },
            gecicicarisor() {

                if (this.geciciyenicari != null) {
                    if (this.secilenkayitlar.length > 0) {
                        this.gecicicaridialogsor = true;
                        this.dialogmesajgecici =
                            " adet kaydın geçici cari bilgilerini değiştirmek istediğinize emin misiniz?";
                    } else {
                        this.text1 = 'Bilet Seçimi Yapmadınız. Lütfen Bilet Seçimi Yapınız..'
                        this.snackbar = true;
                    }

                } else {
                    this.text1 = 'Lütfen Cari Kod Seçimi Yapınız'
                    this.snackbar = true;
                }
            },
            getImgUrl(img) {
                return logoo.logoControl(img);
            },
            denemem() {
                this.secilenkayitlar = []
            },
            BiletListele: BiletListele,
            filtrekayit: filtrekayit,
            filtreiptal: filtreiptal,
            carigetir: carigetir,
            git: git,
            gitliste: gitliste,
            sayfala: sayfala,
            tarihkontrol: tarihkontrol,
            filtrele: filtrele,
            odemeseklikontrol: odemeseklikontrol,
            vergihesapla: vergihesapla,
            servishesapla: servishesapla,
            carikoddegistir: carikoddegistir,
            carigetiryeni: carigetiryeni,
            carigetirgecici: carigetirgecici,
            gecicicarikoddegistir: gecicicarikoddegistir
        },
        beforeMount: beforeMount,


        mounted() {
            this.el = this.$refs.fab.$el
            // this.eltutar=this.$refs.fabtutar.$el
        },
        components: {
            kredikartcomp,
            referansmerkezicomp,
            masrafmerkezicomp,
            analizcomp,
            parainput,
            bolumcomp,
            tarihim
        },
        watch: {
            secilenkayitlar(vallll) {
                // this.nereden = 1;
            },
            tumunuseckaldir(valsec) {

                if (valsec == true && this.aramayapildi == true) {

                    this.yedekListInput.Paging.SayfaNo = 0
                    this.yedekListInput.Paging.VeriAdet = null
                    this.yedekListInput.Paging.SiralamaTip = null

                    var Params = this.yedekListInput;
                    this.$http.post(auth.API_URL + 'api/Ticket/TicketList', Params, {
                        headers: {
                            'Authorization': 'Bearer ' + auth.getAuthHeader()
                        }
                    }).then((response) => {

                        var editdizi = []

                        response.body.forEach(element => {

                            var yenikayit = [];

                            yenikayit.FaturaBilgileri = element.FaturaBilgileri;
                            yenikayit.GenelBilgileri = element.GenelBilgileri;

                            var tarih = {
                                SatisTarihi: tarihkontrol(element.TarihBilgileri.SatisTarihi),
                                IadeTarihi: tarihkontrol(element.TarihBilgileri.IadeTarihi),
                                IptalTarihi: tarihkontrol(element.TarihBilgileri.IptalTarihi)
                            }

                            yenikayit.TarihBilgileri = tarih;

                            var fatura = {
                                FaturaNo: element.FaturaBilgileri.EfaturaBilgileri.FaturaNo,
                                FaturaTarihi: tarihkontrol(element.FaturaBilgileri.EfaturaBilgileri
                                    .GercekFaturaTarihi),
                                FaturaDurumu: element.FaturaBilgileri.EfaturaBilgileri.FaturaDurumu
                            }

                            yenikayit.FaturaBilgileri = fatura;





                            var TutarBilgileri = {
                                AlanVergiTutar: element.TutarBilgileri.AlanVergiTutar,
                                CezaTutar: {
                                    CezaTutar: element.TutarBilgileri.CezaTutar.CezaTutar,
                                },
                                CharterTutar: element.TutarBilgileri.CharterTutar,
                                DigerServisTutar: element.TutarBilgileri.DigerServisTutar,
                                IskontoTutar: element.TutarBilgileri.IskontoTutar,
                                KaTutar: element.TutarBilgileri.KaTutar,
                                NetTutar: {
                                    NetTutar: element.TutarBilgileri.NetTutar.NetTutar.toFixed(2).replace(
                                        /(\d)(?=(\d{3})+\.)/g, '$1,')
                                },
                                PtaTutar: element.TutarBilgileri.PtaTutar,
                                ReserveTutar: element.TutarBilgileri.ReserveTutar,
                                ServisTutar: {
                                    ServisTutar: element.TutarBilgileri.ServisTutar.ServisTutar
                                },
                                TaxTutar: element.TutarBilgileri.TaxTutar,
                                Tutar: {
                                    Tutar: element.TutarBilgileri.Tutar.Tutar.toFixed(2).replace(
                                        /(\d)(?=(\d{3})+\.)/g, '$1,')
                                },
                                YFFTutar: element.TutarBilgileri.YFFTutar,
                                Vergiler: vergihesapla(element.TutarBilgileri),
                                ServisBedeli: servishesapla(element.TutarBilgileri)
                            }


                            yenikayit.TutarBilgileri = TutarBilgileri;
                            var OdemeBilgileri = {
                                SatisSekli: odemeseklikontrol(element.OdemeBilgileri.SatisSekli)
                            }
                            yenikayit.OdemeBilgileri = OdemeBilgileri;
                            editdizi.push(yenikayit)
                        });

                        this.secilenkayitlar = editdizi;
                        this.secilenkayitlaryedek = editdizi;
                        this.aramayapildi = false;



                    }, (response) => {
                        if (response.status === 0) {
                            this.text1 = 'Hata Oluştu'
                            this.snackbar = true
                            this.load1 = true
                            this.progress = false
                        } else {
                            this.text1 = 'Hata Oluştu'
                            this.snackbar = true

                            this.load1 = true
                            this.progress = false
                        }
                    })


                } else if (this.aramayapildi == false && valsec == true) {
                    this.secilenkayitlar = this.secilenkayitlaryedek;
                } else if (this.aramayapildi == false && valsec == false && this.nereden == 0) {
                    this.secilenkayitlar = [];

                } else if (this.aramayapildi == false && valsec == true && this.nereden == 1) {
                    this.nereden = 0;

                }
            },
            searchcari(val) {
                val && this.carigetir(val)
            },
            yenicarisearch(valcari) {
                valcari && this.carigetiryeni(valcari)
            },
            yenicarigecicisearch(valcarigecici) {
                valcarigecici && this.carigetirgecici(valcarigecici)
            },
            'GeciciCari.SatisSekli': function (value3) {


                if (value3 == 'K') {
                    this.bankaposshow = false;
                    this.kredikartshow = false;
                    this.servisposshow = false;
                    this.GeciciCari.KrediKartNo = null;
                    this.GeciciCari.KKCins = null;
                    this.GeciciCari.KKAy = null;
                    this.GeciciCari.KKYil = null;
                    this.GeciciCari.PosKod = null;
                    this.GeciciCari.TaksitKod = null;
                    this.GeciciCari.ServisPosKod = null;
                    this.GeciciCari.ServisTaksitKod = null;
                } else if (value3 == 'P') {
                    this.bankaposshow = false;
                    this.kredikartshow = false;
                    this.servisposshow = false;
                    this.GeciciCari.KrediKartNo = null;
                    this.GeciciCari.KKCins = null;
                    this.GeciciCari.KKAy = null;
                    this.GeciciCari.KKYil = null;
                    this.GeciciCari.PosKod = null;
                    this.GeciciCari.TaksitKod = null;
                    this.GeciciCari.ServisPosKod = null;
                    this.GeciciCari.ServisTaksitKod = null;
                } else if (value3 == 'R') {
                    this.bankaposshow = true;
                    this.kredikartshow = true;
                    this.servisposshow = true;
                } else if (value3 == 'C') {
                    this.bankaposshow = true;
                    this.kredikartshow = true;
                    this.servisposshow = false;
                    this.GeciciCari.ServisPosKod = null;
                    this.GeciciCari.ServisTaksitKod = null;
                } else if (value3 == 'F') {
                    this.bankaposshow = true;
                    this.servisposshow = true;
                    this.kredikartshow = true;

                }

            },
            sayfalama(value) {
                this.BiletListele(value, this.siralamatipi, this.kayitadet,
                    true)
            },

            'siralamatipi': function (valuetip) {
                this.BiletListele(1, valuetip, this.kayitadet, true)

            },
            'kayitadet': function (valueveriadet) {
                this.BiletListele(1, this.siralamatipi, valueveriadet, true)
            },
            gorunumtipi(value2) {
                if (value2 == 'table') {
                    this.tablegorunum = true
                    this.listegorunum = false
                    this.vmodelpagination = false
                    this.listegorunum = false



                    this.yedekListInput.Paging.SayfaNo = 0
                    this.yedekListInput.Paging.VeriAdet = null
                    this.yedekListInput.Paging.SiralamaTip = null

                    var Params = this.yedekListInput;
                    this.$http.post(auth.API_URL + 'api/Ticket/TicketList', Params, {
                        headers: {
                            'Authorization': 'Bearer ' + auth.getAuthHeader()
                        }
                    }).then((response) => {

                       this.itemsticket=response.body


                    }, (response) => {
                        if (response.status === 0) {
                            this.text1 = 'Hata Oluştu'
                            this.snackbar = true
                            this.load1 = true
                            this.progress = false
                        } else {
                            this.text1 = 'Hata Oluştu'
                            this.snackbar = true

                            this.load1 = true
                            this.progress = false
                        }
                    })





                } else {
                    this.tablegorunum = false
                    this.listegorunum = true
                    this.vmodelpagination = true
                    this.listegorunum = true
                }
            },
            searchliste(searchvalue) {
                if (searchvalue != null && searchvalue != '') {
                }
            }
        },
    }


    function filtrekayit() {
        this.dialogfiltre = false
        this.BiletListele(1, this.siralamatipi, this.kayitadet, false)
    }

    function filtreiptal() {
        this.ListInput.BiletNo = null;
        this.ListInput.Filtreler.IadeFatura = false;
        this.ListInput.Filtreler.GiderPusulasi = 0;
        this.ListInput.Filtreler.AcentaFatNo = 0;
        this.ListInput.Filtreler.FaturaStatus = 0;
        this.ListInput.Filtreler.GeciciCari = 0;
        this.ListInput.Filtreler.CariKod = null;
        this.ListInput.Filtreler.Havayollari = [];
        this.ListInput.Filtreler.Parkurlar = [];
        this.ListInput.Filtreler.HatTipi = [];
        this.ListInput.Filtreler.BiletTipi = null;
        this.ListInput.Filtreler.Ucus1 = null;
        this.ListInput.Filtreler.Ucus2 = null;
        this.ListInput.Filtreler.KesenKisi = null;
        this.ListInput.Filtreler.PosKod = null;
        this.ListInput.Filtreler.KrediKartNo = null;
    }



    function carigetir(v) {
        if (v.length >= 0) {
            this.loading = true
            setTimeout(() => {
                this.$http.post(auth.API_URL + 'api/options/CurrentSearch', {
                    q: escape(v)
                }, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {
                    this.statecari = response.body
                    this.Error = false
                }, (response) => {
                    if (response.status === 0) {
                        this.text = 'Service Unavailable'
                        this.snackbar = true
                    } else {
                        this.text = 'Service Unavailable'
                        this.snackbar = true
                    }
                })
                this.loading = false
            }, 500)
        }
    }

    function carigetirgecici(v) {
        if (v.length >= 0) {
            this.loading = true

            this.$http.post(auth.API_URL + 'api/options/CurrentSearch', {
                q: escape(v)
            }, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                this.statecarigecic = response.body
            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                } else {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                }
            })
            this.loading = false

        }
    }


    function carigetiryeni(v) {
        if (v.length >= 0) {
            this.loading = true
            setTimeout(() => {
                this.$http.post(auth.API_URL + 'api/options/CurrentSearch', {
                    q: escape(v)
                }, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {
                    this.statecariyeni = response.body
                    this.Error = false
                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                    } else {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                    }
                })
                this.loading = false
            }, 500)
        }
    }






    function git(v) {
        if (v.GenelBilgileri.Status == 'S' || v.GenelBilgileri.Status == 'Ia') {
            var url = '#/bilet/yeni/id?' + 'isl=get&hyolukod=' + v.GenelBilgileri.HavaYoluKodu + '&biletno=' + v.GenelBilgileri
                .BiletNo + '&ucustipi=' + v.GenelBilgileri.UcusTipi
            window.open(url, '_blank')
        } else if (v.GenelBilgileri.Status == 'V') {
            var url = '#/bilet/yeni/id?' + 'isl=voidget&hyolukod=' + v.GenelBilgileri.HavaYoluKodu + '&biletno=' + v.GenelBilgileri
                .BiletNo + '&ucustipi=' + v.GenelBilgileri.UcusTipi
            window.open(url, '_blank')
        }
    }

    function gitliste(Status, HavaYoluKodu, BiletNo, UcusTipi) {
        if (Status == 'S' || Status == 'Ia') {
            var url = '#/bilet/yeni/id?' + 'isl=get&hyolukod=' + HavaYoluKodu + '&biletno=' + BiletNo + '&ucustipi=' +
                UcusTipi
            window.open(url, '_blank')
        } else if (Status == 'V') {
            var url = '#/bilet/yeni/id?' + 'isl=voidget&hyolukod=' + HavaYoluKodu + '&biletno=' + BiletNo +
                '&ucustipi=' + UcusTipi
            window.open(url, '_blank')
        }
    }


    function filtrele() {

        this.dialogfiltre = true;
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var params = {
            CompanyCode: credentials.SirketKodu
        }

        this.$http.post(auth.API_URL + 'api/TicketDefinitons/AirlineList', params, {
            headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
        }).then((response) => {
            this.itemsairlinelist = response.body
        }, (response) => {
            if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.progress = false

                this.snackbar = true
            } else {
                this.text1 = 'Service Unavailable'
                this.progress = false

                this.snackbar = true
            }
        })

        this.$http.post(auth.API_URL + 'api/TicketDefinitons/ParkurList', params, {
            headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
        }).then((response) => {
            this.itemsparkur = response.body

            this.progress = false
        }, (response) => {
            if (response.status === 0) {
                this.text1 = 'Service Unavailable-parkur'
                this.snackbar = true
                this.progress = false

            } else {
                this.text1 = 'Service Unavailable-parkur'
                this.snackbar = true
                this.progress = false
            }
        })


        this.$http.post(auth.API_URL + 'api/BankPos/List', params, {
            headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
        }).then((response) => {
            this.bankapositems = response.body
            this.progress = false
        }, (response) => {
            if (response.status === 0) {
                this.text1 = 'Service Unavailable-bankpos'
                this.progress = false
                this.snackbar = true
            } else {
                this.text1 = 'Service Unavailable-bankpos'
                this.snackbar = true
                this.progress = false
            }
        })

    }

    function beforeMount() {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        this.progress = true
        this.load = true
        this.load1 = false

       this.date = helpers.getDateNow()
        this.date2 = helpers.getDateNow()

        this.ListInput.SirketKodu = credentials.SirketKodu
        this.ListInput.BaslangicTarihi = this.date
        this.ListInput.BitisTarihi = this.date2
        this.ListInput.Paging.SayfaNo = 1
        this.ListInput.Paging.VeriAdet = 50
        this.ListInput.Paging.SiralamaTip = 'SalesDate'

        this.ListInputYedek = this.ListInput;

        var Params = this.ListInput;
        this.yedekListInput = this.ListInput;
        this.$http.post(auth.API_URL + 'api/Ticket/TicketList', Params, {
            headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
        }).then((response) => {
            if (response.body.length > 0) {
               // this.itemsticket = response.body

                this.tumunuseckaldir = false;
                this.secilenkayitlar = [];
                this.aramayapildi = true;



                if (response.body.length > 0) {
                    this.kayitvarmi = true;
                    this.pagenumber = response.body[0].TotalPage;
                    this.vmodelpagination = true;
                    this.recordcount = 'Toplam ' + response.body[0].TotalCount + ' kayıt listelendi';
                    var editdizi = [];

                   response.body.forEach(element => {

                        var yenikayit = [];

                        yenikayit.FaturaBilgileri = element.FaturaBilgileri;
                        yenikayit.GenelBilgileri = element.GenelBilgileri;

                        var tarih = {
                            SatisTarihi: tarihkontrol(element.TarihBilgileri.SatisTarihi),
                            IadeTarihi: tarihkontrol(element.TarihBilgileri.IadeTarihi),
                            IptalTarihi: tarihkontrol(element.TarihBilgileri.IptalTarihi)
                        }

                        yenikayit.TarihBilgileri = tarih;

                        var fatura = {
                            FaturaNo: element.FaturaBilgileri.EfaturaBilgileri.FaturaNo,
                            FaturaTarihi: tarihkontrol(element.FaturaBilgileri.EfaturaBilgileri
                                .GercekFaturaTarihi),
                            FaturaDurumu: element.FaturaBilgileri.EfaturaBilgileri.FaturaDurumu
                        }

                        yenikayit.FaturaBilgileri = fatura;


                        var TutarBilgileri = {
                            AlanVergiTutar: element.TutarBilgileri.AlanVergiTutar,
                            CezaTutar: {
                                CezaTutar: element.TutarBilgileri.CezaTutar.CezaTutar,
                            },
                            CharterTutar: element.TutarBilgileri.CharterTutar,
                            DigerServisTutar: element.TutarBilgileri.DigerServisTutar,
                            IskontoTutar: element.TutarBilgileri.IskontoTutar,
                            KaTutar: element.TutarBilgileri.KaTutar,
                            NetTutar: {
                                NetTutar: element.TutarBilgileri.NetTutar.NetTutar.toFixed(2).replace(
                                    /(\d)(?=(\d{3})+\.)/g, '$1,')
                            },
                            PtaTutar: element.TutarBilgileri.PtaTutar,
                            ReserveTutar: element.TutarBilgileri.ReserveTutar,
                            ServisTutar: {
                                ServisTutar: element.TutarBilgileri.ServisTutar.ServisTutar
                            },
                            TaxTutar: element.TutarBilgileri.TaxTutar,
                            Tutar: {
                                Tutar: element.TutarBilgileri.Tutar.Tutar.toFixed(2).replace(
                                    /(\d)(?=(\d{3})+\.)/g, '$1,')
                            },
                            YFFTutar: element.TutarBilgileri.YFFTutar,
                            Vergiler: vergihesapla(element.TutarBilgileri),
                            ServisBedeli: servishesapla(element.TutarBilgileri)
                        }


                        yenikayit.TutarBilgileri = TutarBilgileri;
                        var OdemeBilgileri = {
                            SatisSekli: odemeseklikontrol(element.OdemeBilgileri.SatisSekli)
                        }
                        yenikayit.OdemeBilgileri = OdemeBilgileri;
                        editdizi.push(yenikayit)
                    });


                    this.filtreticket = editdizi;

                }


            } else {
                this.text1 = 'Kayıt Bulunamadı'
                this.snackbar = true
            }

            this.progress = false
            this.load1 = true
            this.load = false
        }, (response) => {
            if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
                this.load1 = true
                this.progress = false
            } else {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
                this.load1 = true
                this.progress = false
            }
        })

                console.log('ana program before2 ' + this.date)

    }

    function gecicicarikoddegistir() {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        var biletlistesi = [];

        if (this.secilenkayitlar.length > 0) {
            var biletlistesi = [];


            this.secilenkayitlar.forEach(element => {


                var yenikayit = {
                    SirketKodu: credentials.SirketKodu,
                    HavayoluKodu: element.GenelBilgileri.HavaYoluKodu,
                    FormNo: element.GenelBilgileri.Formno,
                    BiletNo: element.GenelBilgileri.BiletNo
                }
                biletlistesi.push(yenikayit)

            });

            var params = {
                Inputlar: this.ListInputYedek,
                Biletler: biletlistesi,
                YeniCari: this.geciciyenicari,
                Degisikliker: this.GeciciCari
            }
            this.$http.post(auth.API_URL + 'api/Ticket/TicketTempCurrentChange', params, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {

                if (response.body.Status == true) {
                    this.gecicicaridialogsor = false;
                    this.gecicicaridialog = false;
                }

                this.text1 = response.body.ResponseMessage;
                this.snackbar = true;
            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable'
                    this.progress = false

                    this.snackbar = true
                } else {
                    this.text1 = 'Service Unavailable'
                    this.progress = false

                    this.snackbar = true
                }
            })


        } else {
            this.text1 = 'Lütfen Bilet Seçimi Yapınız'
            this.snackbar = true;
        }

    }

    function carikoddegistir() {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        var biletlistesi = [];

        if (this.yenicari != null) {
            if (this.secilenkayitlar.length > 0) {
                var biletlistesi = [];


                this.secilenkayitlar.forEach(element => {

                    var yenikayit = {
                        SirketKodu: credentials.SirketKodu,
                        HavayoluKodu: element.GenelBilgileri.HavaYoluKodu,
                        FormNo: element.GenelBilgileri.Formno,
                        BiletNo: element.GenelBilgileri.BiletNo
                    }
                    biletlistesi.push(yenikayit)

                });
                var params = {
                    Inputlar: this.ListInput,
                    Biletler: biletlistesi,
                    YeniCari: this.yenicari
                }
                this.$http.post(auth.API_URL + 'api/Ticket/TicketCurrentChange', params, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {
                    this.text1 = response.body.ResponseMessage;
                    this.snackbar = true;
                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable'
                        this.progress = false

                        this.snackbar = true
                    } else {
                        this.text1 = 'Service Unavailable'
                        this.progress = false

                        this.snackbar = true
                    }
                })


            } else {
                this.text1 = 'Lütfen Bilet Seçimi Yapınız'
                this.snackbar = true;
            }

        } else {
            this.text1 = 'Lütfen Cari Kod Seçimi Yapınız'
            this.snackbar = true;
        }
    }

    function sayfala(dizi, baslangic, aralik, indexsayisi, siralamatipi) {

        var yenidizi = [];
        this.filtreticket = [];
        var sortdizi = [];
        sortdizi = dizi;
        if (siralamatipi == 0) {
            dizi.sort(function (a, b) {
                return a.TarihBilgileri.SatisTarihi > b.TarihBilgileri.SatisTarihi ? 1 : a.TarihBilgileri.SatisTarihi <
                    b.TarihBilgileri.SatisTarihi ? -1 : 0;
            });
        } else if (siralamatipi == 1) {
            dizi.sort(function (a, b) {
                return b.TarihBilgileri.SatisTarihi > a.TarihBilgileri.SatisTarihi ? 1 : b.TarihBilgileri.SatisTarihi <
                    a.TarihBilgileri.SatisTarihi ? -1 : 0;
            });


        } else if (siralamatipi == 2) {
            dizi.sort(function (a, b) {
                return a.GenelBilgileri.BiletNo > b.GenelBilgileri.BiletNo ? 1 : a.GenelBilgileri.BiletNo <
                    b.GenelBilgileri.BiletNo ? -1 : 0;
            });


        } else if (siralamatipi == 3) {

            dizi.sort(function (a, b) {
                return b.GenelBilgileri.BiletNo > a.GenelBilgileri.BiletNo ? 1 : b.GenelBilgileri.BiletNo <
                    a.GenelBilgileri.BiletNo ? -1 : 0;
            });


        } else {

            dizi.sort(function (a, b) {
                return a.TarihBilgileri.SatisTarihi > b.TarihBilgileri.SatisTarihi ? 1 : a.TarihBilgileri.SatisTarihi <
                    b.TarihBilgileri.SatisTarihi ? -1 : 0;
            });

        }


        if (dizi.length > 0) {

            this.kayitvarmi = true;

            this.pagenumber = Math.ceil(dizi.length / indexsayisi);

            yenidizi = dizi.slice(1 * baslangic, (1) * aralik);

            var editdizi = [];

            yenidizi.forEach(element => {
                var yenikayit = [];
                yenikayit.TutarBilgileri = element.TutarBilgileri;
                yenikayit.FaturaBilgileri = element.FaturaBilgileri;
                yenikayit.GenelBilgileri = element.GenelBilgileri;
                var tarih = {
                    SatisTarihi: tarihkontrol(element.TarihBilgileri.SatisTarihi),
                    IadeTarihi: tarihkontrol(element.TarihBilgileri.IadeTarihi)
                }
                yenikayit.TarihBilgileri = tarih;

                var fatura = {
                    FaturaNo: element.FaturaBilgileri.FaturaNo,
                    FaturaSeri: element.FaturaBilgileri.FaturaSeri,
                    FaturaTarihi: tarihkontrol(element.FaturaBilgileri.FaturaTarihi)
                }
                yenikayit.FaturaBilgileri = fatura;
                editdizi.push(yenikayit)
            });
            this.filtreticket = editdizi;
        } else {
            this.kayitvarmi = false;
            this.vmodelpagination = false;
        }
    }

    function tarihkontrol(v) {

        if (v != "0001-01-01T00:00:00") {
            var parts = v.split("T");
            var parts1 = parts[0].split("-");
            return (parts1[2] + '-' + parts1[1] + '-' + parts1[0]);
        } else {
            return null;
        }
    }

    function odemeseklikontrol(v) {

        if (v == "K") {
            return ("K-Kredili");
        } else if (v == "P") {
            return ("P-Peşin");
        } else if (v == "R") {
            return ("R-Kartlı");
        } else if (v == "C") {
            return ("C-Kartlı");
        } else if (v == "F") {
            return ("F-Kredi Kartlı");
        } else {
            return null;
        }
    }

    function vergihesapla(tutarlar) {

        var gosterilecektutar = 0;

        gosterilecektutar = tutarlar.AlanVergiTutar.AlanVergiTutar + tutarlar.YFFTutar.YFFTutar + tutarlar.TaxTutar.TaxTutar +
            tutarlar.KaTutar.KaTutar;
        gosterilecektutar = Math.round(gosterilecektutar * 100) / 100

        return (gosterilecektutar.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'))
    }

    function servishesapla(tutarlar) {
        var gosterilecektutar = 0;
        gosterilecektutar = tutarlar.ServisTutar.ServisTutar + tutarlar.ReserveTutar.ReserveTutar + tutarlar.DigerServisTutar
            .DigerServisTutar - tutarlar.IskontoTutar.IskontoTutar;

        gosterilecektutar = Math.round(gosterilecektutar * 100) / 100
        return (gosterilecektutar.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'))
    }

    function BiletListele(pagenumber, siralamatipi, veriadet, filtre) {

        if (this.$refs.formbiletrapor.validate()) {

            var bastarih = new Date(this.date)
            var bittarih = new Date(this.date2)

            if (bastarih <= bittarih) {

                var credentials = JSON.parse(window.localStorage.getItem('credentials'));

                this.progress = true
                this.load1 = false
                this.load = true

                if (filtre != true) {
                    this.tumunuseckaldir = false;
                    this.secilenkayitlar = [];
                    this.aramayapildi = true;
                    this.ListInput.SirketKodu = credentials.SirketKodu
                    this.ListInput.BaslangicTarihi = this.date
                    this.ListInput.BitisTarihi = this.date2
                    this.ListInput.Paging.SayfaNo = 1
                    this.ListInput.Paging.VeriAdet = 50
                    this.ListInput.Paging.SiralamaTip = 'SalesDate'
                    this.ListInputYedek = this.ListInput;

                } else {

                    this.ListInput = this.ListInputYedek;
                    this.ListInput.Paging.SayfaNo = pagenumber;
                    this.ListInput.Paging.VeriAdet = veriadet;
                    this.ListInput.SiralamaTip = this.siralamatipi;

                }

                this.yedekListInput = this.ListInput;

                var Params = this.ListInput;


                this.$http.post(auth.API_URL + 'api/Ticket/TicketList', Params, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {
                  //  this.itemsticket = response.body

                    if (response.body.length > 0) {
                        this.kayitvarmi = true;
                        this.pagenumber = response.body[0].TotalPage;
                        this.vmodelpagination = true;
                        this.recordcount = 'Toplam ' + response.body[0].TotalCount + ' kayıt listelendi';
                        var editdizi = [];

                        response.body.forEach(element => {

                            var yenikayit = [];

                            yenikayit.FaturaBilgileri = element.FaturaBilgileri;
                            yenikayit.GenelBilgileri = element.GenelBilgileri;

                            var tarih = {
                                SatisTarihi: tarihkontrol(element.TarihBilgileri.SatisTarihi),
                                IadeTarihi: tarihkontrol(element.TarihBilgileri.IadeTarihi),
                                IptalTarihi: tarihkontrol(element.TarihBilgileri.IptalTarihi)
                            }

                            yenikayit.TarihBilgileri = tarih;

                            var fatura = {
                                FaturaNo: element.FaturaBilgileri.EfaturaBilgileri.FaturaNo,
                                FaturaTarihi: tarihkontrol(element.FaturaBilgileri.EfaturaBilgileri
                                    .GercekFaturaTarihi),
                                FaturaDurumu: element.FaturaBilgileri.EfaturaBilgileri.FaturaDurumu
                            }

                            yenikayit.FaturaBilgileri = fatura;


                            // var biletmini1 = {
                            //     SirketKodu: credentials.SirketKodu,
                            //     HavayoluKodu: element.GenelBilgileri.HavaYoluKodu,
                            //     FormNo: element.GenelBilgileri.Formno,
                            //     BiletNo: element.GenelBilgileri.BiletNo
                            // }

                            // yenikayit.BiletMini = biletmini1;


                            var TutarBilgileri = {
                                AlanVergiTutar: element.TutarBilgileri.AlanVergiTutar,
                                CezaTutar: {
                                    CezaTutar: element.TutarBilgileri.CezaTutar.CezaTutar,
                                },
                                CharterTutar: element.TutarBilgileri.CharterTutar,
                                DigerServisTutar: element.TutarBilgileri.DigerServisTutar,
                                IskontoTutar: element.TutarBilgileri.IskontoTutar,
                                KaTutar: element.TutarBilgileri.KaTutar,
                                NetTutar: {
                                    NetTutar: element.TutarBilgileri.NetTutar.NetTutar.toFixed(2).replace(
                                        /(\d)(?=(\d{3})+\.)/g, '$1,')
                                },
                                PtaTutar: element.TutarBilgileri.PtaTutar,
                                ReserveTutar: element.TutarBilgileri.ReserveTutar,
                                ServisTutar: {
                                    ServisTutar: element.TutarBilgileri.ServisTutar.ServisTutar
                                },
                                TaxTutar: element.TutarBilgileri.TaxTutar,
                                Tutar: {
                                    Tutar: element.TutarBilgileri.Tutar.Tutar.toFixed(2).replace(
                                        /(\d)(?=(\d{3})+\.)/g, '$1,')
                                },
                                YFFTutar: element.TutarBilgileri.YFFTutar,
                                Vergiler: vergihesapla(element.TutarBilgileri),
                                ServisBedeli: servishesapla(element.TutarBilgileri)
                            }


                            yenikayit.TutarBilgileri = TutarBilgileri;
                            var OdemeBilgileri = {
                                SatisSekli: odemeseklikontrol(element.OdemeBilgileri.SatisSekli)
                            }
                            yenikayit.OdemeBilgileri = OdemeBilgileri;
                            editdizi.push(yenikayit)
                        });


                        this.filtreticket = editdizi;

                    } else {
                        this.filtreticket = [];
                        this.kayitvarmi = false;
                        this.vmodelpagination = false;
                        this.recordcount = ""
                        this.text1 = 'Kayıt Bulunamadı....'
                        this.snackbar = true
                    }





                    this.progress = false
                    this.load1 = true
                    this.load = false

                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                        this.load1 = true
                        this.progress = false
                    } else {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true

                        this.load1 = true
                        this.progress = false

                    }
                })
            } else {
                this.text1 = 'Başlangıç tarihi bitiş tarihinden büyük olamaz...'
                this.snackbar = true
            }
        }
    }
</script>

<style>
    .v-list__tile__content {
        overflow: inherit;
    }
</style>